var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#001838"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#64B3E1",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6256 16.0599C33.4431 15.9281 33.2237 15.8572 32.9985 15.8572C32.7733 15.8572 32.5539 15.9281 32.3714 16.0599C31.4528 16.7228 29.3885 17.9342 26.8056 18.9756C24.2199 20.0185 21.1999 20.857 18.3571 20.857C18.0729 20.857 17.8004 20.9699 17.5995 21.1709C17.3985 21.3718 17.2856 21.6443 17.2856 21.9285V33.0028C17.2856 37.327 19.7185 41.347 22.7671 44.3599C25.8142 47.3699 29.6642 49.5599 32.8142 50.1085L32.9985 50.1399L33.1814 50.1085C36.3328 49.5585 40.1814 47.3699 43.2285 44.3599C46.2785 41.347 48.7114 37.327 48.7114 33.0028V21.9285C48.7114 21.6443 48.5985 21.3718 48.3975 21.1709C48.1966 20.9699 47.9241 20.857 47.6399 20.857C44.7971 20.857 41.7785 20.0185 39.1928 18.9756C36.6085 17.9328 34.5442 16.7213 33.6256 16.0599ZM19.4285 33.0028V22.967C22.3071 22.7899 25.1885 21.9385 27.6071 20.9628C29.8756 20.0485 31.7971 18.9985 32.9985 18.2228C34.1985 18.9985 36.1214 20.0485 38.3914 20.9628C40.8085 21.9385 43.6914 22.7913 46.5685 22.967V33.0028C46.5685 36.5313 44.5556 40.0356 41.7228 42.8342C38.9542 45.5699 35.5785 47.4542 32.9985 47.9628C30.4185 47.4542 27.0414 45.5699 24.2728 42.8342C21.4399 40.037 19.4285 36.5342 19.4285 33.0042M41.2456 27.6999C41.3468 27.602 41.4276 27.4851 41.4835 27.3559C41.5395 27.2267 41.5694 27.0878 41.5717 26.9471C41.574 26.8063 41.5485 26.6665 41.4967 26.5356C41.4449 26.4047 41.3679 26.2853 41.2699 26.1842C41.172 26.0831 41.0551 26.0022 40.9259 25.9463C40.7968 25.8903 40.6579 25.8604 40.5171 25.8581C40.3764 25.8559 40.2365 25.8814 40.1056 25.9331C39.9748 25.9849 39.8553 26.062 39.7542 26.1599L29.4056 36.1742L26.2199 33.2799C26.0082 33.0984 25.7341 33.0066 25.4558 33.024C25.1774 33.0414 24.9169 33.1666 24.7294 33.373C24.5419 33.5795 24.4423 33.8509 24.4518 34.1296C24.4612 34.4083 24.5789 34.6723 24.7799 34.8656L28.7085 38.437C28.91 38.6202 29.1736 38.7197 29.4459 38.7155C29.7181 38.7113 29.9785 38.6035 30.1742 38.4142L41.2456 27.6999Z",
    fill: "#ECF6FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWarranty);
export default __webpack_public_path__ + "static/media/home-warranty.90394cbf9950db8abf1681ca081ae8e6.svg";
export { ForwardRef as ReactComponent };